__turbopack_context__.v({
  "avatarContainer": "ProfileImageInput-module-scss-module__YxAQ1a__avatarContainer",
  "avatarWrapper": "ProfileImageInput-module-scss-module__YxAQ1a__avatarWrapper",
  "deleteBtn": "ProfileImageInput-module-scss-module__YxAQ1a__deleteBtn",
  "imagePreview": "ProfileImageInput-module-scss-module__YxAQ1a__imagePreview",
  "replaceBtn": "ProfileImageInput-module-scss-module__YxAQ1a__replaceBtn",
});
